// extracted by mini-css-extract-plugin
module.exports = {"root":"_daf019","learnMoreAboutReviews":"_6be5a2"};